<template>
  <div class="card elevation-3">
    <v-card>
      <v-card-title>
        <span class="headline">Email Reply</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 600px;">
        <v-progress-linear :indeterminate="processBar" height="2" class="my-0"></v-progress-linear>
        <v-form onSubmit="return false;" ref="form" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <label for="note">Reply</label>
                <v-textarea
                  v-model="editedItem.message"
                  counter
                  maxlength="500"
                  full-width
                  single-line
                  outline
                  label="Type your Reply here"
                  height="210px"
                  no-resize
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <br />
      <v-divider class="noteDivider"></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" flat @click="sendEmail">Send</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    rules: {
      required: value => !!value || "Required."
    },
    processBar: false,

    editedItem: {
      message: ""
    }
  }),
 
  methods: {
    async sendEmail() {
      let {iso_id, user_id} = this.$route.params;
      if (this.$refs.form.validate()) {
        this.processBar = true;
        await axios.post('/send_iso_reply',{
            iso_id: iso_id,
            user_id: user_id,
            message: this.editedItem.message
          })
          .then(resp => {
            if (resp.data.success) {
              this.flash(resp.data.message, "message", {
                timeout: 3000
              });
              this.processBar = false;
              if (this.processBar == false) {
                window.close();
              }
            }
          })
          .catch(error => {
            this.flash("There was an error", "error", {
              timeout: 3000
            });
          });
      } else {
        alert("Please file out all the required fields.");
      }
    }
  }
};
</script>
<style>
.v-toolbar__content {
  padding-bottom: 10px;
}
</style>

<style scoped>
.elevation-1 {
  box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.2), 0 0px 0px 0 rgba(0, 0, 0, 0.14),
    0 0px 0px 0 rgba(0, 0, 0, 0.12) !important;
}

.mytable .v-table tbody tr:not(:last-child) {
  border-bottom: none !important;
}

.btn-group button {
  float: left; /* Float the buttons side by side */
}

.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.v-timeline {
  margin: 0px !important;
  padding-top: 0px !important;
}

thead {
  display: none !important;
}

th {
  display: none !important;
}

.timelineContainer {
  padding: 0px;
}

.v-timeline-item {
  padding-bottom: 0px !important;
}


i.fas.fa-headset {
  color: white !important;
}

i.fas.fa-check-circle {
  color: white !important;
}

i.fas.fa-money-check-alt {
  color: white !important;
}

i.fas.fa-chart-line {
  color: white !important;
}

i.fas.fa-male {
  color: white !important;
}

i.fas.fa-user-tie {
  color: white !important;
}

/*i.fas.fa-poo {*/
/*    color: white !important;*/
/*}*/

i.fas.fa-poo {
  color: brown !important;
}

i.fas.fa-keyboard {
  color: white !important;
}

i.fas.fa-file-signature {
  color: white !important;
}

i.fas.fa-hand-holding-usd {
  color: white !important;
}

i.fas.fa-crown {
  /*color: white !important;*/
}

i.fas.fa-user {
  /*color: white !important;*/
}

i.fas.fa-briefcase {
  color: white !important;
}

i.fas.fa-th-list {
  /*color: white !important;*/
}

i.fas.fa-user-tie {
  /*color: white !important;*/
}

.v-card.v-sheet.theme--light {
  height: auto;
}
</style>
